import type { CollaborateUser } from "../types/collaborate";

export function filterCollaborateUsers(users: CollaborateUser[], query: string): CollaborateUser[] {
  const q = query.trim().toLowerCase();
  if (!q) {
    return users;
  }
  return users.filter(
    (u) => u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q)
  );
}

export type MentionListItem = { id: string; label: string; email: string; role?: string };

export function userToMentionItem(user: CollaborateUser): MentionListItem {
  return { id: user.id, label: user.name, email: user.email, role: user.role };
}
